const INTEGRATION_PATH = '/assets/js/integration/';

/**
 * Folder (with a trailing slash) of the first script URL that points into the Angular build
 * output folder of the WordPress theme, or undefined when none does. Used as the webpack
 * public path so lazy chunks are requested next to `main.js`.
 */
export function getIntegrationFolder(
  scriptUrls: (string | null | undefined)[]
): string | undefined {
  const url = scriptUrls.find(src => src?.includes(INTEGRATION_PATH));

  return url?.slice(0, url.lastIndexOf('/') + 1);
}
